<template>
  <v-card>
    <v-card-text>
      <v-card-title v-if="expiryDate">
        <div>
          Your password will expire on {{formateDate(expiryDate)}}
        </div>
      </v-card-title>
      <message :messages="messages"></message>
      <form>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex md5 xs12>
              <v-text-field type="password" :label="labels.password" v-model="passwordForm.password" :error-messages="errors.collect('password')" v-validate="'required|max:128'" data-vv-name="password" :data-vv-as="labels.password"></v-text-field>
            </v-flex>
            <v-flex md7 xs12></v-flex>
            <v-flex md5 xs12>
              <v-text-field type="password" :label="labels.newPassword" v-model="passwordForm.newPassword" :error-messages="errors.collect('newPassword')" v-validate="'required|max:128|confirmed:cfmPassword'" data-vv-name="newPassword" :data-vv-as="labels.newPassword"></v-text-field>
            </v-flex>
            <v-flex md7 xs12></v-flex>
            <v-flex md5 xs12>
              <v-text-field type="password" :label="labels.cfmPassword" v-model="passwordForm.cfmPassword" :error-messages="errors.collect('cfmPassword')" v-validate="'required|max:128'" data-vv-name="cfmPassword" :data-vv-as="labels.cfmPassword" ref="cfmPassword"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSubmit">
                Change Password
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatDisplayDateTime } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import { USER_PASSWORD_SUCCESS } from '@/store/types'
export default {
  data() {
    return {
      labels: {
        password: 'Current Password*',
        newPassword: 'New Password*',
        cfmPassword: 'Confirm Password*'
      },
      passwordForm: {
        password: '',
        newPassword: '',
        cfmPassword: ''
      },
      submitting: false
    }
  },
  computed: {
    expiryDate() {
      return this.$store.state.user.profile.passwordExpiryDate
    }
  },
  methods: {
    formateDate(date) {
      return formatDisplayDateTime(date)
    },
    doSubmit() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          const apiURI = this.$store.state.user.profile.menu.changePassword
          if (apiURI) {
            this.submitting = true
            this.$http.post(apiURI, this.passwordForm)
              .then(result => {
                const { data } = result
                if (data) {
                  // Show message via notify
                  this.message(data)

                  // Commit result (expiryDate - if available)
                  this.$store.commit(USER_PASSWORD_SUCCESS, data)

                  // Reinit data
                  this.passwordForm.password = ''
                  this.passwordForm.newPassword = ''
                  this.passwordForm.cfmPassword = ''
                  this.$validator.pause()
                  this.$nextTick(() => {
                    this.$validator.reset()
                    this.$validator.resume()
                  })
                }
                this.submitting = false
              })
              .catch(err => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)

                  // Reinit data
                  this.passwordForm.password = ''
                }
                this.submitting = false
              })
          } else {
            this.errorMessage('Invalid API URL')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
